import React from "react";
import BackDrop from "../BackDrop/BackDrop";
import SliderProject from "../SliderProject/SliderProject";
import "./DetailsModal.css";

const DetailtsModal = ({ detailsP }) => {
  const {
    images,
    name,
    details,
    feature,
    technologyUse,
    liveLink,
    clientCode,
    serverCode,
  } = detailsP;

  return (
    <div className="">
      <input type="checkbox" id="my-modal-6" class="modal-toggle" />
      <div class="modal modal-bottom sm:modal-middle  ">
        <label
          for="my-modal-6"
          className="bg-[#000000a4] fixed w-full h-screen top-[50%] left-[50%] transform translate-x-[-50%]  translate-y-[-50%] -z-10 cursor-pointer "
        ></label>
        <div
          style={{ height: "90%" }}
          className=" md:w-[800px] w-[90%] bg-own-primary  lg:h-[auto]   h-[100%]  overflow-auto modalWrapper p-[30px] rounded-md border-2 border-own-border-color border-opacity-20"
        >
          <label
            for="my-modal-6"
            class="btn bg-own-secondary border-own-secondary btn-sm btn-circle absolute right-0 top-5"
          >
            ✕
          </label>

          <div className="grid grid-cols-1  gap-3">
            <div>
              <SliderProject images={images} />
              <div className="mt-6"></div>
              <h2 className="text-2xl md:text-3xl mt-4 font-semibold text-own-gray-white capitalize">
                {name}
              </h2>
            </div>
            <div>
              <span className="text-xl md:text-2xl mb-2 font-bold text-own-gray-white">
                👉 Project Key Feature 👇
              </span>

              <ul className="mt-10">
                {feature?.map((text, index) => (
                  <li className="text-[15px] py-1 text-own-ternary list-disc">
                    {text}
                  </li>
                ))}
              </ul>
              <span className="text-xl font-semibold my-1 inline-block text-own-gray-white bg-own-gray-black px-4 rounded-md py-2 ">
                👉 Technologies Used 👇
              </span>
              <ul className="flex flex-wrap">
                {technologyUse?.map((text) => (
                  <li className="mr-2 font-medium text-own-secondary capitalize ">
                    <span className="text-2xl fon-bold"> . </span>
                    {text}
                  </li>
                ))}
              </ul>
              <div className="flex items-center justify-around mt-6">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={liveLink}
                  className="inline-flex px-4 rounded-xl cursor-pointer text-[20px] items-center justify-center bg-own-secondary "
                >
                  <i className="ri-play-line mr-1 "></i>Live{" "}
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex px-4 rounded-xl cursor-pointer text-[20px] items-center justify-center bg-own-secondary "
                  href={clientCode}
                >
                  <i class="ri-github-line mr-1"></i>Client
                </a>
                {serverCode && (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex px-4 rounded-xl cursor-pointer text-[20px] items-center justify-center bg-own-secondary "
                    href={serverCode}
                  >
                    <i class="ri-github-line mr-1"></i> Server
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailtsModal;
